import { useQuery } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { getCurrentUser } from '@/api/actions/users/usersActions'
import { Queries } from '@/api/queries.enum'
import type { ICurrentUserResponse, IUserApiError } from '@/api/actions/users/usersActions.types'

interface IUseCurrentUserOptions {
    enabled?: boolean
}

export function useCurrentUser(options: IUseCurrentUserOptions = {}) {
    const { enabled = true } = options

    return useQuery<ICurrentUserResponse, AxiosError<IUserApiError>>({
        queryKey: [Queries.getCurrentUser],
        queryFn: getCurrentUser,
        enabled,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 5, // 5 minutes
        gcTime: 1000 * 60 * 30, // 30 minutes - longer cache for current user
    })
}
